"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.L10nModule = void 0;
var L10nModule = /** @class */function () {
  function L10nModule() {}
  Object.defineProperty(L10nModule.prototype, "current", {
    get: function () {
      return this.currentLocale;
    },
    set: function (locale) {
      this.currentLocale = locale.replace('_', '-');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(L10nModule.prototype, "globalize", {
    get: function () {
      return this.l10nModule;
    },
    set: function (mod) {
      this.l10nModule = mod;
    },
    enumerable: false,
    configurable: true
  });
  return L10nModule;
}();
exports.L10nModule = L10nModule;